
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"24","fill":"#007F32","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.846 0a.534.534 0 000 1.069h2.728l3.722 11.905a.534.534 0 101.02-.319L7.27 9.305h3.546l.7 4.785-2.795.459a.455.455 0 00-.028.005c-1.136.25-1.635 1.198-1.678 2.024-.02.41.065.834.274 1.175.215.35.584.637 1.083.637H24.85v-1.069H8.37c-.043 0-.102-.015-.171-.127a1.009 1.009 0 01-.117-.56c.024-.468.283-.907.827-1.033l15.13-2.486a.535.535 0 00.414-.341l3.202-8.624a.535.535 0 00-.5-.72H5.431L4.477.374A.534.534 0 003.967 0H.846zm4.92 4.498l1.169 3.737h3.723l-.546-3.737H5.766zm9.788 8.928l-2.985.49-.674-4.612h3.66v4.122zm4.286-.704l-3.217.528V9.304h3.701l-.484 3.418zm3.719-.611l-2.613.43.458-3.237H24.6l-1.042 2.807zm2.827-7.613l-1.388 3.737h-3.443l.53-3.737h4.3zm-9.763 0h4.382l-.53 3.737h-3.852V4.498zm-5.43 0h4.361v3.737h-3.816l-.546-3.737zM9.94 20.691c-.62 0-1.12.5-1.12 1.12 0 .62.5 1.12 1.12 1.12.62 0 1.12-.5 1.12-1.12 0-.62-.5-1.12-1.12-1.12zm-2.19 1.12c0-1.21.98-2.19 2.19-2.19s2.19.98 2.19 2.19S11.15 24 9.94 24s-2.19-.979-2.19-2.19zm13.264 0c0-.62.5-1.12 1.12-1.12.62 0 1.12.5 1.12 1.12 0 .62-.5 1.12-1.12 1.12-.62 0-1.12-.5-1.12-1.12zm1.12-2.19c-1.21 0-2.189.98-2.189 2.19S20.925 24 22.135 24s2.189-.979 2.189-2.19c0-1.21-.98-2.188-2.19-2.188z"}})])
          )
        }
      }
    